import styled from 'styled-components'
import { useTranslation, Trans } from 'react-i18next'
import { Button } from '@/components/button'
import { createModal, useModalize } from '@/components/modalize/mui'
import { colors } from '@/styles'
import { CautionIcon } from '@/components/icons'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fcf5d8;
  height: 112px;
  width: 100%;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 24px;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  button {
    width: 100%;
  }
`

const Title = styled.h5`
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
`

const Paragraph = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.grey16};
  margin: 12px 0 24px;
`

const BoldedText = styled.span`
  font-weight: 700;
`

const AddressModal = ({ id, address, availableAttempts, handleRetrieveAddress }) => {
  const { t } = useTranslation()
  const { close } = useModalize()

  return (
    <Container>
      <IconWrapper>
        <CautionIcon />
      </IconWrapper>
      <TextWrapper>
        <Title>{t('r.profile.edit.address_lookup_modal.title', 'Confirm Address Selection')}</Title>
        <Paragraph>
          <Trans i18nKey="r.profile.edit.address_lookup_modal.text">
            'Are you sure you wish to set <BoldedText>{{ address }}</BoldedText> as your address? By
            confirming, you will use 1 of your {{ availableAttempts }} remaining address changes.'
          </Trans>
        </Paragraph>
        <ButtonWrapper>
          <Button onClick={close} theme="secondary">
            {t('common.cancel', 'Cancel')}
          </Button>
          <Button
            onClick={() => {
              handleRetrieveAddress(id)
              close()
            }}
          >
            {t('l.application.view.i_confirm.button', 'I Confirm')}
          </Button>
        </ButtonWrapper>
      </TextWrapper>
    </Container>
  )
}

const showConfirmAddressSelectionModal = createModal(AddressModal, {
  showClose: true,
  width: '416px'
})

export default showConfirmAddressSelectionModal
